// only pages should be imported and used here
// http://bradfrost.com/blog/post/atomic-web-design/

let routes = [
  {
    path: '/',
    name: 'Home'
  },
  {
    path: '*',
    redirect: '/'
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes-singlelanguage.js